var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("login.passwordChangeForm")))]),
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.passwordChange($event)
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("login.company"),
              rules: _vm.companyRules,
              required: "",
              name: "company"
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.passwordChange($event)
              }
            },
            model: {
              value: _vm.company,
              callback: function($$v) {
                _vm.company = $$v
              },
              expression: "company"
            }
          }),
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("login.login"),
              rules: _vm.loginRules,
              required: "",
              name: "login"
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.passwordChange($event)
              }
            },
            model: {
              value: _vm.login,
              callback: function($$v) {
                _vm.login = $$v
              },
              expression: "login"
            }
          }),
          _c("v-text-field", {
            attrs: {
              name: "password",
              label: _vm.$t("login.password"),
              rules: _vm.oldPasswordRules,
              type: "password",
              required: ""
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.passwordChange($event)
              }
            },
            model: {
              value: _vm.oldPassword,
              callback: function($$v) {
                _vm.oldPassword = $$v
              },
              expression: "oldPassword"
            }
          }),
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("login.newPassword"),
              password: "",
              type: "password",
              rules: _vm.newPasswordRules,
              required: ""
            },
            model: {
              value: _vm.newPassword,
              callback: function($$v) {
                _vm.newPassword = $$v
              },
              expression: "newPassword"
            }
          }),
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("login.newPasswordRepeat"),
              type: "password",
              password: "",
              rules: _vm.newRepeatPasswordRules,
              required: ""
            },
            model: {
              value: _vm.newPasswordRepeat,
              callback: function($$v) {
                _vm.newPasswordRepeat = $$v
              },
              expression: "newPasswordRepeat"
            }
          }),
          _c(
            "v-btn",
            { staticClass: "success", on: { click: _vm.passwordChange } },
            [_vm._v(_vm._s(_vm.$t("global.save")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }